import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./i18n/config";
import { offlineStorage } from "./lib/offlineStorage";

// Initialize offline storage
offlineStorage.initialize().catch(console.error);

createRoot(document.getElementById("root")!).render(<App />);
